
@defer (on viewport) {
  <article 
    class="suggested-points__point"
    (click)="handleClick(point())"
  >
    @if (!isImgError) {
      <header class="point__header">
        <img 
          [src]="point().img" 
          [attr.alt]="('Imagen' | translate) + ' ' + point().title"
          (error)="handleImgError()"
        >
      </header>
    }
    
    <main class="point__main">
      <h2 class="point__title ci-paragraph-p1-semibold">
        {{ point().title | translate }}
      </h2>
      
      <div class="point__info">
        <ci-icon
          class="info__icon"
          name="duracion"
          type="svg"
        ></ci-icon>
        
        <span class="info__text ci-footer-semibold">
          {{ point().duration | duration }}
        </span>
      </div>
    </main>
    
    <footer class="point__footer">
      <ci-icon
        class="point__add-icon"
        name="btn-add"
        type="svg"
        scale="1.5x"
      ></ci-icon>
    </footer>
  </article>
  
} @placeholder {
  <!-- TODO: IMPLEMENT SKELETON LOADING STATE -->
  <div style="height: 100px;">Loading...</div>
}